<!--
  One parent-filtered child list of the provision type. The create action carries the parent FK
  pre-filled and read-only (CONFIG-012).

  The six assignment tables render the "Bedingungssatz" column through the custom-field template
  below (an empty set is the statement "Alle Verträge (unbedingt)", not a blank cell) and, on row
  selection, the read-only condition preview of the selected row's set.
-->
<div class="cp-provision-type-child-table">

    @if (initialized && childWidget) {

        <mvs-widget
                [widgetData]="childWidget"
                [importObjectContext]="importContext"
                (onObjectSelect)="onRowSelect($event)">

            <ng-template let-object="object" mvs-widget-custom-field-directive
                         area="columns" [fieldId]="conditionSetFieldId" label="Bedingungssatz">
                @if (conditionSetName(object); as setName) {
                    <div class="flex flex-column">
                        <span>{{ setName }}</span>
                        @if (conditionSetAlias(object); as setAlias) {
                            <span class="text-xs text-color-secondary">{{ setAlias }}</span>
                        }
                    </div>
                } @else {
                    <span class="text-color-secondary font-italic">{{ unconditionalLabel }}</span>
                }
            </ng-template>

        </mvs-widget>

        @if (child?.conditionSetPreview) {
            <div class="mt-3">
                @if (selectedAssignment) {
                    <cp-provision-assignment-condition-preview
                            [provisionTypeId]="provisionTypeId"
                            [assignmentName]="selectedAssignment.name"
                            [conditionSetId]="selectedAssignment.conditionSetId"
                            [conditionSetName]="selectedAssignment.conditionSetName"
                            [conditionSetAlias]="selectedAssignment.conditionSetAlias"
                            (onJumpToConditionSet)="onPreviewJump($event)"
                            (onClose)="onPreviewClose()">
                    </cp-provision-assignment-condition-preview>
                } @else {
                    <div class="flex align-items-center gap-2 text-sm text-color-secondary">
                        <i class="fa-regular fa-hand-pointer"></i>
                        <span>Zeile anklicken, um die Bedingungen ihres Bedingungssatzes anzuzeigen.</span>
                    </div>
                }
            </div>
        }

    } @else if (initialized) {
        <p-message severity="info" text="Kein Provisionstyp ausgewählt." styleClass="w-full"></p-message>
    } @else {
        <p-skeleton height="12rem"></p-skeleton>
    }

</div>
